var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"point-indicator"},[(_vm.point === 'Positive')?_c('img',{attrs:{"src":"/img/joey_smalls_happy.svg"}}):(_vm.point === 'Neutral')?_c('img',{attrs:{"src":"/img/joey_smalls_neutral.svg"}}):(_vm.point === 'Negative')?_c('img',{attrs:{"src":"/img/joey_smalls_mad.svg"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }